module.exports = __webpack_public_path__ + "img/108.897deb42.jpg";